function Help() {
  return (
    <div className="min-h-screen flex justify-center p-4 mt-8">
      <p className="max-w-xl">
        For questions or comments, please email{" "}
        <a className="text-blue-500" href="mailto:liminal.warmth@gmail.com">
          liminal_warmth@gmail.com
        </a>
        , or tweet{" "}
        <a className="text-blue-500" href="https://twitter.com/liminal_warmth">
          @liminal_warmth
        </a>{" "}
        or{" "}
        <a className="text-blue-500" href="https://twitter.com/mattroll_">
          @mattroll_
        </a>{" "}
      </p>
    </div>
  );
}

export default Help;
